import React, { useState, useEffect } from 'react'

function LoadingComponent(props) {
  var messages = props.messages ? props.messages : [
    'Loading your Data...',
    'Please wait a moment...',
    // 'Fetching data...',
    // 'Almost there...'
  ]
  companyName = companyName ? companyName : process.env.companyName;

  if(!companyName){
		let logoName = window.location.hostname.split('.')[0];
		logo = logoNameArray.indexOf(logoName)!=-1 ? logoName : "rockmetric";
	}else logo = companyName;
	logo = logo.replace(" ","");
	setCSSComp(process.env,"all");

  var isAppLoading = props?.applicationLoading ? props.applicationLoading : false
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentMessageIndex((prevIndex) => (prevIndex + 1) % messages?.length);
    }, 5000);
    return () => clearInterval(intervalId);
  }, [messages?.length]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setCurrentMessageIndex((prevIndex) => (prevIndex + 1) % messages?.length);
    }, 5000);
    return () => clearTimeout(timeoutId);
  }, [currentMessageIndex, messages?.length]);
	let logoIMG = logo ? `/assets/images/logos/${logo}.png` : `/assets/images/logos/rockmetric.png`;

  return (
    <div>
      {isAppLoading == true ? (
                <div className="loading-container">
                    <div className="loading-circle"></div>
                    <div className="loading-image-container">
                        <img
                            src={logoIMG}
                            alt="Logo"
                            className="loading-image"
                        />
                    </div>
                </div>
            ) : <><div className={`d-flex justify-content-center ${props.component=="summary"? "mg-t-25":"mg-t-100" } flex-column align-items-center justify-content-between`}  style={{ height: "110px" }}>
          <div className="inner-loader"></div>
          <span className='font-weight-900 tx-22' style={{ fontFamily: "sans-serif", color: '#013682', paddingBottom: '20px' }}>{messages?.[currentMessageIndex]}</span>
        </div></>}
    </div>
  );
};



export default LoadingComponent
